import React from 'react';
import { formatHeroCurrency } from './simpleProductPageShared';
import './OfferSavingsBadge.css';

export default function OfferSavingsBadge({ savings }) {
  if (!savings) return null;
  return <span className="ab-offer-savings">
    Save {formatHeroCurrency(savings.amount)}{savings.percent > 0 ? ` (${savings.percent}%)` : ''}
  </span>;
}
